
<div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0">
    <div class="md:flex md:items-center md:justify-end w-full sm:w-auto md:h-full md:w-1/2 py-8 px-4 sm:p-12 md:p-16 sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card">

        <div class="w-full max-w-80 sm:w-80 mx-auto sm:mx-0">

            <div>
                <img *ngIf="logoUrl" [src]="logoUrl" alt="Logo" class="sidebar-logo rounded-2xl">
            </div>

            <div class="mt-8 text-4xl font-extrabold tracking-tight leading-tight">{{'registration.form.register' | transloco}}</div> <!-- Registrati (TITOLO PAGINA)-->
            <div class="flex items-baseline mt-0.5 font-medium">
                <div>{{'registration.form.noAccount' | transloco}}</div><!-- Hai già un account? (FRASE SOTTO AL TITOLO)-->
                <a class="ml-1 text-500 hover:underline link-drake"
                   [routerLink]="['/sign-in']">
                    {{'registration.form.signUp' | transloco}}<!-- Login  (LINK DI LOGIN)-->
                </a>
            </div>

            <div>
                
                <router-outlet></router-outlet>
            </div>

            <button class="fuse-mat-button-large w-full mt-6"
                        mat-flat-button
                        [color]="'primary'"
                        [ngStyle]="{'background-color': customColor, 'color': textColor}"
                        (click)="signUp()">
                {{'registration.form.registerButton' | transloco}}<!-- Invia (BOTTONE FONDO PAGINA)-->
            </button>

        </div>
    </div>
    <div class="relative hidden md:flex flex-auto items-center justify-center w-1/2 h-full p-16 lg:px-28 overflow-hidden " [ngStyle]="{'background-color': backgroundColor, 'color': textColor}">
        <!-- Background - @formatter:off -->
        <!-- Rings -->
        <div [innerHTML]="introductionHtml"></div>

    </div>
</div>
<div class="header">
    <languages></languages>
</div>
